export default __webpack_public_path__ + "static/media/diverse-logo.b32ea2e4.svg";